import { Injectable } from '@angular/core';
import {NeoRestService} from '../neo-rest/neo-rest.service';

@Injectable()
export class NeoHotelService {

    constructor(
        private _rest: NeoRestService
    ) {}

    /**
     * Detalles del hotel
     *
     * @param  hotelId del hotel
     * @return Un objeto observable
     * */
    getHotel(hotelId) {
        return this._rest.get(`/hotel/${hotelId}`);
    }

    /**
     * Search
     *
     * @return Un objeto observable
     * */
    search() {
        return this._rest.get(`/hotel/`);
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/neo-hotel/neo-hotel.service.ts